// The one place this package imports @match-feed/core. Core is not published yet,
// so it is imported by relative path; switch to the package name once it is.
export * from '../../core/src/index.ts';
